import * as React from 'react';
import ReactSlider from 'react-slider';
import styled from 'styled-components';
import { ledBrightnessPercentConvert } from '../../util';

const ColorSliderComponent = styled(ReactSlider)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .color-slider-thumb {
    background-color: ${({ theme }) => theme.colors.background3};
    color: ${({ theme }) => theme.colors.font1};
    padding: 10px 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 10px;
  }
  .color-track {
    height: 8px;
    width: 100%;
    left: 0 !important;
    right: 0 !important;
    top: calc(50% - 4px);

    &:nth-child(2) {
      display: none;
    }
  }
`;

const ColorCircle = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  margin-bottom: 5px;
  border: ${({ theme }) => `1px solid ${theme.colors.font1}`};
`;

export interface IColor {
  Brightness: number;
  Color: {
    hue: number;
    saturation: number;
  };
}

export interface IColorSliderProps {
  color: IColor;
  onColorUpdate: (v: number) => void;
  testId?: string;
}

export const ColorSlider = (props: IColorSliderProps) => {
  const { onColorUpdate, testId, color } = props;
  const { Color, Brightness } = color;
  const { hue, saturation } = Color;

  return (
    <ColorSliderComponent
      data-testid={testId || 'color-slider'}
      className="color-slider"
      thumbClassName="color-slider-thumb"
      trackClassName="color-track"
      onChange={value => {
        onColorUpdate(ledBrightnessPercentConvert(value, true));
      }}
      value={ledBrightnessPercentConvert(Brightness)}
      renderThumb={(thumbProps, state) => (
        <div {...thumbProps}>
          <ColorCircle
            style={{
              background: `hsl(${hue}, ${saturation}%, ${ledBrightnessPercentConvert(
                Brightness
              )}%)`
            }}
          />
          {state.valueNow}%
        </div>
      )}
      renderTrack={trackProps => (
        <div
          {...trackProps}
          style={{
            opacity: 0.5,
            background: `linear-gradient(to right, hsl(0, 0%, 0%), hsl(${hue}, ${saturation}%, 50%))`
          }}
        />
      )}
    />
  );
};

export default ColorSlider;
